__turbopack_context__.v({
  "active": "CustomizerModal-module__GU_XXW__active",
  "closeButton": "CustomizerModal-module__GU_XXW__closeButton",
  "content": "CustomizerModal-module__GU_XXW__content",
  "customizerModalWrapper": "CustomizerModal-module__GU_XXW__customizerModalWrapper",
  "header": "CustomizerModal-module__GU_XXW__header",
  "tabButton": "CustomizerModal-module__GU_XXW__tabButton",
  "tabs": "CustomizerModal-module__GU_XXW__tabs",
  "title": "CustomizerModal-module__GU_XXW__title",
});
